import { Outlet, Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import StickySupport from "@/components/StickySupport";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/dmc-election", label: "DMC Election" },
  { to: "/vision", label: "Vision" },
  { to: "/research", label: "Research" },
  { to: "/endorsements", label: "Endorsements" },
  { to: "/awards", label: "Awards" },
  { to: "/gallery", label: "Gallery" },
  { to: "/connect", label: "Connect" },
];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white text-[hsl(var(--fg))]">
      {/* Top strip */}
      <div className="bg-[hsl(var(--primary))] text-white text-xs">
        <div className="container-x flex items-center justify-between py-2">
          <span className="tracking-wider uppercase">
            Sewa · Samarpan · Sankalp · Safalta
          </span>
          <span className="hidden sm:block">DMC Elections · 31st May 2026</span>
        </div>
      </div>

      {/* Header */}
      <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-[hsl(var(--border-c))]">
        <div className="container-x flex items-center justify-between py-4">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_doctor-leader-delhi/artifacts/r36y6jy5_WhatsApp%20Image%202026-05-05%20at%2012.52.39%20AM.jpeg"
              alt="Sankalp"
              className="w-11 h-11 object-contain"
            />
            <span className="leading-tight">
              <span className="block font-display text-xl tracking-wide">
                Dr. Abhishek Garg
              </span>
              <span className="block text-[10px] uppercase tracking-[0.25em] text-[hsl(var(--fg-muted))]">
                Team Sankalp · DMC Executive Member
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm font-medium tracking-wide transition-colors ${
                    isActive
                      ? "text-[hsl(var(--accent))]"
                      : "text-[hsl(var(--fg))] hover:text-[hsl(var(--accent))]"
                  }`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#support"
              data-testid="header-support-cta"
              className="hidden sm:inline-flex btn-primary text-xs px-5 py-2.5"
            >
              Support Now
            </a>
            <button
              data-testid="mobile-menu-toggle"
              className="lg:hidden p-2"
              onClick={() => setOpen((v) => !v)}
              aria-label="menu"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
        {open && (
          <div className="lg:hidden border-t border-[hsl(var(--border-c))] bg-white">
            <div className="container-x py-4 flex flex-col gap-3">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                  className={({ isActive }) =>
                    `text-sm py-2 ${
                      isActive
                        ? "text-[hsl(var(--accent))] font-semibold"
                        : "text-[hsl(var(--fg))]"
                    }`
                  }
                  end={n.to === "/"}
                >
                  {n.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </header>

      <main className="flex-1">
        <Outlet context={{ settings }} />
      </main>

      <Footer settings={settings} />
      <StickySupport settings={settings} />
    </div>
  );
}
